import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-角标 402",
  "use": "icon-角标 402-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-角标 402\"><path d=\"M746.666667 149.333333a64 64 0 0 1 64 64v661.333334l-298.666667-133.333334L213.333333 874.666667V213.333333a64 64 0 0 1 64-64h469.333334z m0 64H277.333333v562.666667l234.666667-104.746667 234.666667 104.746667V213.333333z m-106.666667 256v64H384v-64h256z m0-149.333333v64H384v-64h256z\" p-id=\"25919\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol